import { render, staticRenderFns } from "./LapsedBranchesReport.vue?vue&type=template&id=4412ede0&"
import script from "./LapsedBranchesReport.vue?vue&type=script&lang=js&"
export * from "./LapsedBranchesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports